import React from "react";
import { useSelector } from "react-redux";

const useGetVisibleForSuAdmins = () => {
  const { role } = useSelector(state => state.auth);
  const allowedRole = 3; 

  return allowedRole === +role;
}

export default useGetVisibleForSuAdmins;